import { PlankPatternForm } from "./PlankPattern.form";

/** The size of the square tile; the narrow one is half as wide. Photos go to the tiles they look like. */
export const AlternatingPatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="alternating"
    width={{ value: "13", min: 3, max: 60, labelKey: "TILE_WIDTH" }}
    height={{ value: "13", min: 3, max: 60, labelKey: "TILE_HEIGHT" }}
  />
);
